import { useTranslation } from 'react-i18next';

import { NAMESPACE } from './namespace';

/**
 * Gets an instance translations for security journey translations
 *
 * @returns translations
 */
export const useSecurityJourneyTranslations = () => {
  return useTranslation(NAMESPACE);
};
